import { render, staticRenderFns } from "./AdminAboutPage.vue?vue&type=template&id=fa4e4da2&"
import script from "./AdminAboutPage.vue?vue&type=script&lang=js&"
export * from "./AdminAboutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports